import script from "./CustomLogoLoader.vue?vue&type=script&lang=ts&setup=true"
export * from "./CustomLogoLoader.vue?vue&type=script&lang=ts&setup=true"

import "./CustomLogoLoader.vue?vue&type=style&index=0&id=62f16cb0&scoped=true&lang=css"

import exportComponent from "/var/www/prod/contentfactory/auth/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62f16cb0"]])

export default __exports__